import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { getServiceRecordChangeLabels } from 'pages/MaintenancePage/helpers/getServiceRecordChangeLabels';
import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ServiceRecordChangeEntry: FunctionComponent<Props> = ({
    change,
    className = '',
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const fieldLabel = getServiceRecordChangeLabels(t)[change.fieldChanged];

    // Empty sides (a cleared field, or the missing side of a photo add/remove) render
    // the page's em dash; performedAt entries store ISO strings, so those display as
    // dates like every other timestamp on the page.
    const formatValue = (value: string): string => {
        if (!value) {
            return t.EM_DASH;
        }

        return change.fieldChanged === 'performedAt' ? new Date(value).toLocaleDateString() : value;
    };

    return (
        <VerticalContainer
            className={`${styles.serviceRecordChangeEntry} ${className}`}
            testId={testId}>
            <Wrapper className={styles.fieldName}>{fieldLabel}</Wrapper>

            <HorizontalContainer className={styles.valueRow}>
                <Wrapper className={styles.oldValue}>{formatValue(change.oldValue)}</Wrapper>

                <Wrapper className={styles.arrow}>{t.SERVICE_RECORD_CHANGE_ARROW}</Wrapper>

                <Wrapper className={styles.newValue}>{formatValue(change.newValue)}</Wrapper>
            </HorizontalContainer>

            <Wrapper className={styles.attribution}>
                {t.SERVICE_RECORD_CHANGED_BY({
                    when: new Date(change.changedAt).toLocaleDateString(),
                    who: change.changedBy
                })}
            </Wrapper>
        </VerticalContainer>
    );
};

export default ServiceRecordChangeEntry;
